import React from 'react';

import './Input.scss';

export interface SelectProps
  extends Omit<React.InputHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  onChange?: (value: string) => void;
  options: { label: string; value: string }[];
}

const Select = ({ className, onChange, options, ...props }: SelectProps) => (
  <select
    className={`input select ${className}`}
    onChange={(e) => onChange?.(e.target.value)}
    {...props}
  >
    {options.map(({ label, value }) => (
      <option key={label} value={value}>
        {label}
      </option>
    ))}
  </select>
);

Select.defaultProps = {
  onChange: () => {},
};

export default Select;
